<app-dialog-container>
  <div mat-dialog-content class="dialogContent">
    <!-- MOTIVO -->
    <mat-form-field class="input" appearance="outline">
      <mat-label>COMENTÁRIO</mat-label>
      <input
        cdkFocusInitial
        matInput
        class="uppercase"
        [(ngModel)]="element"
      />
    </mat-form-field>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close (click)="clickNo()">SAIR</button>
    <button mat-button cdkFocusInitial (click)="clickOk()">CONTINUAR</button>
  </div>
</app-dialog-container>
